module.exports = __webpack_public_path__ + "static/media/numeros.467e18e4.png";